import React from 'react';
import { Link } from 'react-router-dom';
import { FaBolt, FaWrench, FaPaintRoller, FaHammer, FaSnowflake, FaBroom, FaWindowMaximize, FaHome } from 'react-icons/fa';
import ServiceCard from './ServiceCard';
import './Services.css';

const Services = () => {
    const services = [
        {
            icon: <FaBolt />,
            title: 'Electrician',
            description: 'Professional electrical services for your home and office. Installation, repair, and maintenance.',
            professionals: 1200,
            slug: 'electrician'
        },
        {
            icon: <FaWrench />,
            title: 'Plumber',
            description: 'Expert plumbing solutions for all your needs. Leak repairs, installations, and emergency services.',
            professionals: 950,
            slug: 'plumber'
        },
        {
            icon: <FaPaintRoller />,
            title: 'Painter',
            description: 'Transform your space with professional painting services. Interior and exterior work.',
            professionals: 800,
            slug: 'painter'
        },
        {
            icon: <FaHammer />,
            title: 'Carpenter',
            description: 'Custom woodwork and furniture repair. Quality craftsmanship for your projects.',
            professionals: 650,
            slug: 'carpenter'
        },
        {
            icon: <FaSnowflake />,
            title: 'AC Repair',
            description: 'Keep cool with our AC installation, repair, and maintenance services.',
            professionals: 720,
            slug: 'ac-repair'
        },
        {
            icon: <FaBroom />,
            title: 'Cleaning',
            description: 'Professional cleaning services for homes and offices. Deep cleaning and regular maintenance.',
            professionals: 1500,
            slug: 'cleaning'
        },
        {
            icon: <FaWindowMaximize />,
            title: 'Glass & Windows',
            description: 'Window installation, repair, and glass work. Expert handling of all glass needs.',
            professionals: 420,
            slug: 'glass-windows'
        },
        {
            icon: <FaHome />,
            title: 'Home Renovation',
            description: 'Complete home renovation and remodeling services. Bring your vision to life.',
            professionals: 350,
            slug: 'home-renovation'
        }
    ];

    return (
        <section className="services-section section" id="services">
            <div className="container">
                <div className="section-header">
                    <h2>Our Services</h2>
                    <p>Find the right professional for any home service you need</p>
                </div>
                <div className="services-grid">
                    {services.map((service, index) => (
                        <Link to={`/service/${service.slug}`} key={index} style={{ textDecoration: 'none' }}>
                            <ServiceCard
                                icon={service.icon}
                                title={service.title}
                                description={service.description}
                                professionals={service.professionals}
                            />
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
